export function Logo() {
  return <h2 className="font-ms-madi flex items-center text-4xl">AC</h2>;
}
